import { render, staticRenderFns } from "./AITagIcon.vue?vue&type=template&id=dde024e0&scoped=true"
import script from "./AITagIcon.vue?vue&type=script&lang=js"
export * from "./AITagIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde024e0",
  null
  
)

export default component.exports